export default "__VITE_ASSET__Ed$FrCgE__"